import { Load } from "../../lib/model/Load";
import { LoadType } from "../../lib/model/LoadType";
import { BookMultiOrder } from "../../features/bookMulti/model/BookMultiOrder";

export class LoadValidator {
  validLoads = (loads: Load[]): Load[] => {
    return loads.map(l => {
      if (
        l.type === LoadType.Europallet &&
        (l.length !== 80 || l.width !== 120)
      ) {
        return {
          ...l,
          type: LoadType.Other,
          label: "Europalette, Übermaß"
        };
      }
      return l;
    });
  };

  orderWithValidLoads = (order: BookMultiOrder): BookMultiOrder => {
    return {
      ...order,
      singlePoint: {
        ...order.singlePoint,
        loads: this.validLoads(order.singlePoint.loads)
      },
      multiPoints: order.multiPoints.map(p => ({
        ...p,
        loads: this.validLoads(p.loads)
      }))
    };
  };
}
